import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { areaApi, selectAllAreas, overrideArea } from '../../reducers/areaSlice';
import { templateApi } from '../../reducers/templateSlice';

import CheckboxTree from 'react-checkbox-tree';
import 'react-checkbox-tree/lib/react-checkbox-tree.css';
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css

import NewTemplatePopup from './NewTemplatePopup'

const AreaTreeView = ({ selectedTemplate, selectedArea, onTemplateSelected, onAreaSelected, onNewArea }) => {
    const [firstTemplate, setFirstTemplate] = useState(null)
    const [expanded, setExpanded] = useState([])
    const [nodes, setNodes] = useState([])
    const [showTemplatePopup, setShowTemplatePopup] = useState(false);
    const [templateAreaSelected, setTemplateAreaSelected] = useState(null)
    const [templateSelected, setTemplateSelected] = useState(null)
    const areas = useSelector((state) => selectAllAreas(state))
    const status = useSelector((state) => state.templateReducer.status)
    const lastTemplate = useSelector((state) => state.templateReducer.lastTemplate)

    const dispatch = useDispatch()

    const onDeleteArea = (area) => {
        if(area.templates.length > 0) {
            confirmAlert({
                //   title: 'Confirm to submit',
                  message: "Impossibile cancellare un'Area che contiene almeno un template",
                  buttons: [
                    {
                        label: 'OK',
                        onClick: () => {}
                    }
                  ]
                });
        } else {
            if(areas.length > 0 && areas[0].templates.length > 0) {
                if(onTemplateSelected) onTemplateSelected(areas[0].templates[0])
            } 
            dispatch(areaApi.delete(area))
        }
    }

    const onNewTemplate = (area) => {
        setShowTemplatePopup(true)
        setTemplateAreaSelected(area)
        setTemplateSelected(null)
    }

    const onUpdateTemplate = (area, template) => {
        setShowTemplatePopup(true)
        setTemplateAreaSelected(area)
        setTemplateSelected(template)
    }

    const onDeleteTemplate = (area, template) => {
        setTemplateAreaSelected(area)
        // setTemplateSelected(template)

        dispatch(templateApi.delete({ 
            areaId: area.id,
            template: template
        }))
    }

    useEffect(() => {
        dispatch(areaApi.fetchAll())
    }, [dispatch])

    useEffect(() => {
        let newNodes = []
        let newExpanded = ['head']
        let firstFound = false

        areas.forEach((area) => {
            let children = []
            area.templates.forEach((template) => {
                if(!firstFound && firstTemplate === null && selectedTemplate === null) {
                    // firstTemplate = template
                    onTemplateSelected(template)
                    setFirstTemplate(template)
                    firstFound = true
                }

                children.push({
                    id: template.id,
                    value: 'tpl_'+template.id,
                    label: (<span className="node" style={{cursor: 'pointer', position: 'relative'}} onClick={(event) => { if(onTemplateSelected) onTemplateSelected(template) } }>
                        { selectedTemplate && selectedTemplate.id === template.id ? <b>{template.name}</b> : template.name }
                        <span className="node-icon" style={{position: 'absolute', right: '-48px'}}>
                            &nbsp;<span className="btn btn-primary" style={{padding: '2px'}}>
                                <span className="mdi mdi-pencil" onClick={(event) => { onUpdateTemplate(area, template); event.stopPropagation(); } }></span>
                            </span>
                            &nbsp;<span className="btn btn-danger" style={{padding: '2px'}}>
                                <span className="mdi mdi-close" onClick={(event) => { onDeleteTemplate(area, template); event.stopPropagation(); } }></span>
                            </span>
                        </span>
                    </span>),
                    showCheckbox: false
                })
            })

            newNodes.push({
                value: 'area_'+area.id,
                label: (<span className="node" style={{cursor: 'pointer', position: 'relative'}} onClick={(event) => { if(onAreaSelected) onAreaSelected(area) } }>
                    {/* <div style={{width: '16px', height: '16px', backgroundColor: area.color, display: 'inline-block', position: 'relative', top: '2px', marginRight: '2px'}}></div> */}
                    <span style={{color: area.color}}>{ selectedArea && selectedArea.id === area.id ? <b>{area.name}</b> : area.name }</span>
                    <span className="node-icon" style={{position: 'absolute', right: '-48px'}}>
                        &nbsp;<span className="node-icon btn btn-primary" style={{padding: '2px'}}>
                            <span className="mdi mdi-plus" onClick={(event) => { onNewTemplate(area); event.stopPropagation(); } }></span>
                        </span>
                        &nbsp;<span className="node-icon btn btn-danger" style={{padding: '2px'}}>
                            <span className="mdi mdi-close" onClick={(event) => { onDeleteArea(area); event.stopPropagation(); } }></span>
                        </span>
                    </span>
                </span>),
                showCheckbox: false,
                children: children,
                icon: (<div style={{width: '16px', height: '16px', backgroundColor: area.color, display: 'inline-block', position: 'relative', top: '2px'}}></div>)
            })    
            newExpanded.push('area_'+area.id)
        })

    
        setNodes([{
            id: 'head',
            value: 'head',
            label: (<b style={{textDecoration: 'underline'}}>QUESTIONARI</b>),
            showCheckbox: false,
            children: newNodes,
        }])
        setExpanded(newExpanded)
    }, [areas, selectedTemplate, selectedArea, setExpanded])

    useEffect(() => {
        if(lastTemplate && templateAreaSelected) {
            let templates = []
            switch(status) {
                case 'template/create/succeeded': 
                    templates = [ ...templateAreaSelected.templates ]
                    templates.push(lastTemplate)
                    break;
                case 'template/update/succeeded': 
                    templateAreaSelected.templates.forEach(t => {
                        if(t.id === lastTemplate.id) templates.push(lastTemplate)
                        else templates.push(t)
                    });
                    break;
                case 'template/delete/succeeded': 
                    if(onTemplateSelected) onTemplateSelected(areas[0].templates[0])
                    templateAreaSelected.templates.forEach(t => {
                        if(t.id !== lastTemplate.id) templates.push(t)
                    });
                    break;
                default: break;
            }
    
            dispatch(overrideArea({ ...templateAreaSelected, templates: templates}))
        }
    }, [status])

    return (<div style={{borderRight: '1px solid #dedede'}}>
        <CheckboxTree
            nodes={nodes}
            expanded={expanded}
            onExpand={(expanded) => setExpanded(expanded)}
        />
        <span className="btn btn-primary d-block text-white mt-4 mr-4" style={{cursor: 'pointer'}} onClick={(event) => { if(onNewArea) onNewArea() }}>
          Crea nuova area
        </span>
        { 
            showTemplatePopup
                ? <NewTemplatePopup area={templateAreaSelected} template={templateSelected} onToggle={() => { setShowTemplatePopup(false) }} />
                : null
        }
    </div>)
}

export default AreaTreeView;